import React from 'react';
import { Link } from 'react-router-dom';
import './CallToAction.css';

const CallToAction = () => (
  <section className="cta-section">
    <div className="cta-section__inner">
      <div className="container">
        <div className="cta-section__content">
          <div className="cta-section__text">
            <span className="section-label section-label--white">JOIN THE MOVEMENT</span>
            <h2 className="cta-section__title">
              Every talented young<br />person deserves a chance<br />to <em>thrive</em>.
            </h2>
            <p className="cta-section__desc">
              Whether you are a student, employer, partner, or supporter — there is a place for you in the YOCILAB ecosystem. Let's build the future together.
            </p>
          </div>
          <div className="cta-section__actions">
            <Link to="/youth-summit/register" className="cta-section__btn cta-section__btn--accent">
              Register for the Summit
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                <path d="M2 7H12M12 7L8 3M12 7L8 11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </Link>
            <Link to="/programs/yocilab-academy" className="cta-section__btn cta-section__btn--ghost">
              Explore the Academy
            </Link>
            <Link to="/contact" className="cta-section__btn cta-section__btn--ghost">
              Partner With Us
            </Link>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default CallToAction;
